import { Badge, type BadgeProps } from "../../Badge";

export type MenuItemBadgeProps = BadgeProps;

export function MenuItemBadge({ ...props }: MenuItemBadgeProps) {
  return <Badge {...props} />;
}

MenuItemBadge.displayName = "MenuItem.Badge";
